import './assets/app.css'

import { createApp } from 'vue'
import ImpressionsApp from '@/components/app/ImpressionsApp.vue'

createApp(ImpressionsApp).mount('#app')
